import { toast } from 'sonner'

/**
 * Custom hook for displaying toast messages using Sonner
 *
 * @returns {Function} showToast - Function to display a toast message
 *
 * @example
 * const showToast = useGlobalMessage()
 * showToast({ message: 'Success!', messageType: 'success' })
 * showToast({ message: 'Error occurred', messageType: 'error' })
 * showToast({ message: 'Warning', messageType: 'warning' })
 */
export const useGlobalMessage = () => {
    return ({ message, messageType = 'success' }) => {
        // Capitalize first letter
        const formattedMessage = message.charAt(0).toUpperCase() + message.slice(1)

        switch (messageType) {
            case 'success':
                toast.success(formattedMessage)
                break
            case 'error':
                toast.error(formattedMessage)
                break
            case 'warning':
                toast.warning(formattedMessage)
                break
            default:
                toast(formattedMessage)
        }
    }
}
